import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0dfd4d4e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "row mt-1 mb-4 ps-5 pe-5 justify-content-center"
}
const _hoisted_2 = {
  class: "offer-banner",
  role: "region",
  "aria-label": "Oferta Exclusiva: R$500 OFF no Plano Pró"
}
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"bg-grid\" aria-hidden=\"true\" data-v-0dfd4d4e></div><div class=\"banner-glow glow-1\" data-v-0dfd4d4e></div><div class=\"banner-glow glow-2\" data-v-0dfd4d4e></div><div class=\"banner-glow glow-3\" data-v-0dfd4d4e></div><div class=\"bg-particles\" aria-hidden=\"true\" data-v-0dfd4d4e><span class=\"bp bp1\" data-v-0dfd4d4e></span><span class=\"bp bp2\" data-v-0dfd4d4e></span><span class=\"bp bp3\" data-v-0dfd4d4e></span><span class=\"bp bp4\" data-v-0dfd4d4e></span><span class=\"bp bp5\" data-v-0dfd4d4e></span><span class=\"bp bp6\" data-v-0dfd4d4e></span></div><div class=\"ribbon\" aria-hidden=\"true\" data-v-0dfd4d4e>R$500 OFF</div>", 6)
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"offer-badge\" data-v-0dfd4d4e>OFERTA EXCLUSIVA • TEMPO LIMITADO</div><h2 class=\"banner-title\" data-v-0dfd4d4e><span class=\"fire-icon\" aria-hidden=\"true\" data-v-0dfd4d4e>🔥</span><span class=\"text-gold\" data-v-0dfd4d4e>R$500 OFF</span><span class=\"text-white\" data-v-0dfd4d4e> no Plano PRO</span></h2><p class=\"text-subtitle\" data-v-0dfd4d4e><span class=\"subtitle-highlight\" data-v-0dfd4d4e>+400 labs</span> e uma trilha completa<br data-v-0dfd4d4e>do básico ao avançado. </p>", 3)
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "banner-button-shine",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "banner-button-text" }, "Garantir desconto", -1))
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = {
  class: "banner-right",
  "aria-hidden": "true"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "countdown-heading" }, "Oferta expira em:", -1))
const _hoisted_17 = {
  class: "countdown",
  role: "timer",
  "aria-live": "off",
  "aria-label": "Tempo restante para a oferta"
}
const _hoisted_18 = { class: "countdown-block" }
const _hoisted_19 = { class: "countdown-number" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "countdown-label" }, "dias", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "countdown-sep",
  "aria-hidden": "true"
}, ":", -1))
const _hoisted_22 = { class: "countdown-block" }
const _hoisted_23 = { class: "countdown-number" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "countdown-label" }, "horas", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "countdown-sep",
  "aria-hidden": "true"
}, ":", -1))
const _hoisted_26 = { class: "countdown-block" }
const _hoisted_27 = { class: "countdown-number" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "countdown-label" }, "min.", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "countdown-sep",
  "aria-hidden": "true"
}, ":", -1))
const _hoisted_30 = { class: "countdown-block" }
const _hoisted_31 = { class: "countdown-number" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "countdown-label" }, "seg.", -1))

import { computed, onBeforeUnmount, onMounted, reactive, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const OFFER_URL = "https://pay.hackingclub.com/cart/pro";
const DEADLINE = new Date("2026-04-10T23:58:59");

const now = ref(Date.now());
let timer: ReturnType<typeof setInterval> | null = null;

onMounted(() => {
  timer = setInterval(() => {
    now.value = Date.now();
  }, 1000);
});

onBeforeUnmount(() => {
  if (timer !== null) {
    clearInterval(timer);
  }
});

const isVisible = computed(() => now.value < DEADLINE.getTime());

const timeLeft = computed(() => {
  const diff = Math.max(0, DEADLINE.getTime() - now.value);
  const totalSeconds = Math.floor(diff / 1000);
  return {
    days: Math.floor(totalSeconds / 86400),
    hours: Math.floor((totalSeconds % 86400) / 3600),
    minutes: Math.floor((totalSeconds % 3600) / 60),
    seconds: totalSeconds % 60,
  };
});

const pad = (n: number) => String(n).padStart(2, "0");

const goToOffer = () => {
  window.open(OFFER_URL, "_blank", "noopener,noreferrer");
};

return (_ctx: any,_cache: any) => {
  return (_unref(isVisible))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", { class: "banner-content" }, [
            _hoisted_9,
            _createElementVNode("button", {
              class: "banner-button",
              type: "button",
              onClick: goToOffer
            }, _hoisted_14)
          ]),
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("span", _hoisted_19, _toDisplayString(pad(_unref(timeLeft).days)), 1),
                _hoisted_20
              ]),
              _hoisted_21,
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("span", _hoisted_23, _toDisplayString(pad(_unref(timeLeft).hours)), 1),
                _hoisted_24
              ]),
              _hoisted_25,
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("span", _hoisted_27, _toDisplayString(pad(_unref(timeLeft).minutes)), 1),
                _hoisted_28
              ]),
              _hoisted_29,
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("span", _hoisted_31, _toDisplayString(pad(_unref(timeLeft).seconds)), 1),
                _hoisted_32
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})